var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum } from 'class-validator';
import { BookingDeclineReason } from '../enums/booking-decline-reason.enum.js';
/**
 * Body for `POST /appointments/:id/decline-booking` (PRD #1343, RS-002). A
 * decline REQUIRES a reason from the fixed {@link BookingDeclineReason} set —
 * it is shown to the patient verbatim, and the inbox must never become a
 * free-text channel. The decline itself routes through the practice-origin
 * cancel path (never fee-eligible).
 */
export class DeclineBookingDto {
    reason;
}
__decorate([
    IsEnum(BookingDeclineReason),
    __metadata("design:type", String)
], DeclineBookingDto.prototype, "reason", void 0);
//# sourceMappingURL=decline-booking.dto.js.map